import {Navigate, useRoutes} from "react-router-dom";
import {lazy, Suspense} from "react";
import Loader from "../components/Layout/Loader";
import LayoutWithoutBar from "../layout/LayoutWithoutBar";

const Home = lazy(() => import("../pages/B_body/Home"));
const MovieDetails = lazy(() => import("../pages/B_body/MovieDetails"));
const PeopleDetails = lazy(() => import("../pages/B_body/PeopleDetails"));


const NoAuthRouter = () => useRoutes([
    {path: "/", element: <Navigate to="home" replace/>},
    {
        path: "/",
        element: <LayoutWithoutBar/>,
        children: [
            {
                path: "/home",
                element: (
                    <Suspense fallback={<Loader/>}>
                        <Home/>
                    </Suspense>
                ),
            },
            {
                path: "/movie/:id",
                element: (
                    <Suspense fallback={<Loader/>}>
                        <MovieDetails/>
                    </Suspense>
                ),
            },
            {
                path: "/people/:id",
                element: (
                    <Suspense fallback={<Loader/>}>
                        <PeopleDetails/>
                    </Suspense>
                ),
            },
            {path: "*", element: <Navigate to="/404" replace/>},
        ]
    },
    {path: "*", element: <Navigate to="/404" replace/>},
])

export default NoAuthRouter;

/*<Routes>
    <Route path="/" element={<LayoutWithBar/>}>
        <Route path="dashboard" index element={<Dashboard/>}/>
        <Route path="research" element={<Research/>}/>
        <Route path="favoris" element={<Favorite/>}/>
        <Route path="seen-movie" element={<SeenMovie/>}/>
        <Route path="movie/:id" element={<SeenMovie/>}/>
        <Route path="people/:id" element={<SeenMovie/>}/>
        <Route path="settings" element={<Settings/>}/>
    </Route>
</Routes>*/
